import React from "react";

const ErrorMessage = ({ message, style }) => {
  if (message) {
    return (
      <div className="text-danger" style={style}>
        {message}
      </div>
    );
  }
};

export default ErrorMessage;
